import React, { memo } from 'react';
import type { ControlRendererProps } from '../ControlRenderer';
import { getBaseControlClassName } from '../utils/classNameUtils';

const FONT_SIZE_MAP: Record<string, string> = {
  sm: '0.75rem',
  md: '0.875rem',
  lg: '1rem',
  xl: '1.25rem',
};

const LabelControl = memo<ControlRendererProps>(({ control }) => {
  const containerClassName = getBaseControlClassName(control, {
    disabled: control.disabled,
  });

  const content =
    (control.config?.content as string) ??
    (control.label || control.description) ??
    String(control.defaultValue ?? '');

  const fontSize = FONT_SIZE_MAP[(control.config?.fontSize as string) || 'md'] ?? '0.875rem';
  const fontWeight = (control.config?.fontWeight as string) ?? 'normal';
  const textAlign = (control.config?.alignment as React.CSSProperties['textAlign']) ?? undefined;
  const color = (control.config?.color as string) ?? undefined;

  return (
    <div className={containerClassName}>
      <div
        id={control.id}
        className="control__label-display"
        role="doc-subtitle"
        style={{ fontSize, fontWeight, textAlign, color }}
      >
        {content}
      </div>

      {control.helpText && (
        <div className="control__help">{control.helpText}</div>
      )}
    </div>
  );
});

LabelControl.displayName = 'LabelControl';

export default LabelControl;
